<template>
  <div class="trend-card">
    <div class="chart-toolbar">
      <span>今日用水量</span>
    </div>
    <div ref="chartRef" class="trend-chart"></div>
  </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import * as echarts from "echarts";

const chartRef = ref(null);
let chartInstance = null;

const timeData = ["00:00", "04:00", "08:00", "12:00", "14:00", "16:00", "20:00"];
const waterData = [120, 360, 520, 480, 610, 680, 490];

const initChart = () => {
  if (!chartRef.value) return;
  chartInstance = echarts.init(chartRef.value);
  chartInstance.setOption({
    grid: {
      top: 28,
      left: 56,
      right: 50,
      bottom: 100,
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "rgba(7, 45, 48, 0.94)",
      borderColor: "rgba(105, 255, 239, 0.55)",
      textStyle: {
        color: "#fff",
        fontSize: 22,
      },
      formatter(params) {
        const item = params[0];
        return `${item.axisValue}<br/>今日用水量：${item.value}吨`;
      },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: timeData,
      axisTick: { show: false },
      axisLine: {
        lineStyle: {
          color: "rgba(150, 255, 246, 0.28)",
        },
      },
      axisLabel: {
        color: "#f1fffb",
        fontSize: 22,
        fontWeight: "bold",
        margin: 18,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "rgba(107, 255, 239, 0.11)",
        },
      },
    },
    yAxis: {
      type: "value",
      min: 0,
      // max: 360,
      interval: 60,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: "rgba(225, 255, 251, 0.86)",
        fontSize: 22,
        formatter(value) {
          return value === 0 ? "0" : value;
        },
      },
      splitLine: {
        lineStyle: {
          color: "rgba(107, 255, 239, 0.13)",
        },
      },
    },
    series: [
      {
        name: "今日用水量",
        type: "line",
        smooth: false,
        symbol: "circle",
        symbolSize: 9,
        data: waterData,
        label: {
          show: true,
          position: "top",
          color: "#ffffff",
          fontSize: 20,
          fontWeight: "bold",
          formatter: "{c}吨",
        },
        itemStyle: {
          color: "#d7fff9",
          borderColor: "#8dfff5",
          borderWidth: 2,
          shadowColor: "rgba(105, 255, 239, 0.8)",
          shadowBlur: 12,
        },
        lineStyle: {
          width: 4,
          color: "#9ffff6",
          shadowColor: "rgba(75, 255, 239, 0.55)",
          shadowBlur: 12,
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(78, 255, 232, 0.46)" },
            { offset: 0.55, color: "rgba(13, 164, 151, 0.28)" },
            { offset: 1, color: "rgba(1, 79, 74, 0.06)" },
          ]),
        },
      },
    ],
  });
};

const resizeChart = () => {
  if (chartInstance) chartInstance.resize();
};

onMounted(() => {
  nextTick(initChart);
  window.addEventListener("resize", resizeChart);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart);
  if (chartInstance) {
    chartInstance.dispose();
    chartInstance = null;
  }
});
</script>

<style lang="less" scoped>
.trend-card {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.trend-card::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: linear-gradient(rgba(94, 255, 241, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(94, 255, 241, 0.05) 1px, transparent 1px);
  background-size: 34px 34px;
}

.chart-toolbar {
  position: relative;
  height: 68px;
  line-height: 68px;
  padding-left: 50px;
  color: #ffffff;
  font-size: 26px;
  font-weight: bold;
  text-align: left;
   &::before {
    content: "";
    position: absolute;
    left: 30px;
    top: 20px;
    width: 5px;
    height: 28px;
    background: #39fff0;
    box-shadow: 0 0 12px rgba(57, 255, 240, 0.8);
  }
}

.legend-line {
  width: 20px;
  height: 3px;
  background: #9ffff6;
  box-shadow: 0 0 8px rgba(105, 255, 239, 0.8);
}

.arrow {
  font-size: 22px;
  line-height: 1;
}

.trend-chart {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
}
</style>
